/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventSummary_smartHoldEventInfo = {
    readonly isPreTravelTime: boolean;
    readonly isPostTravelTime: boolean;
    readonly originEvent: {
        readonly title: string | null;
        readonly eventKey: {
            readonly externalEventId: string;
        };
    };
    readonly " $refType": "EventSummary_smartHoldEventInfo";
};
export type EventSummary_smartHoldEventInfo$data = EventSummary_smartHoldEventInfo;
export type EventSummary_smartHoldEventInfo$key = {
    readonly " $data"?: EventSummary_smartHoldEventInfo$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventSummary_smartHoldEventInfo">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EventSummary_smartHoldEventInfo",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPreTravelTime",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPostTravelTime",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "originEvent",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventKey",
                    "kind": "LinkedField",
                    "name": "eventKey",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "externalEventId",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "SmartHoldEventInfo",
    "abstractKey": null
} as any;
(node as any).hash = 'b876ad9745d4a4b454c43c609a1ca14c';
export default node;
